export default __webpack_public_path__ + "static/media/finder_grid_enable.3d3f7742.svg";